export const fields = [
    { name: "commento", label: "👩‍⚕️‍  Commento del medico", placeholder: "Ogni a capo crea un elenco puntato" },
    { name: "alimenti", label: "🥙  Alimenti consigliati", placeholder: "Ogni a capo crea un elenco" },
    { name: "integratori", label: "💊  Integratori consigliati", placeholder: "Ogni a capo crea un elenco" },
    { name: "checkup", label: "🩺  Check-up consigliati", placeholder: "Ogni a capo crea un elenco" },
];
